import React, { Component } from "react";

import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';

import { withStyles} from '@material-ui/core/styles';
import YouTube from 'react-youtube';


import Fade from '@material-ui/core/Fade';
import PlayIcon from 'mdi-material-ui/PlayCircleOutline'


const styles = theme => ({
  root:{
    position: "relative",
    height: "75vh",
    minHeight: 500,
    overflow: "hidden",

    background: theme.palette.background.white,
  },
  container:{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",

    display: "flex",
    flexDirection:"column",
    justifyContent: "center",
    alignContent: "center",

    clipPath:"polygon(0 0%, 100% 0%, 100% 80%, 90% 82%, 80% 89%, 70% 93%, 60% 92%, 50% 94%, 40% 97%, 30%95%, 20% 97%, 10% 99%, 0% 98%)",

    background: theme.palette.background.dark,
    opacity: 0.5,
  },
  overlayImg:{

    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    opacity: 0.3,
  },
  videoContainer:{
    display: "relative",
    height: "75vh",
    minHeight: "500",
    width: "100%",
    clipPath:"polygon(0 0%, 100% 0%, 100% 80%, 90% 82%, 80% 89%, 70% 93%, 60% 92%, 50% 94%, 40% 97%, 30%95%, 20% 97%, 10% 99%, 0% 98%)",
  },

  playButton:{
    color: "white",
    fontSize: 100,

    "&:hover":{
      color: "rgba(255,255,255, 0.8)"
    }
  }
})

const opts = {
  height: '100%',
  width: '100%',
  playerVars: {
    autoplay: 0,
    controls: 0,
    iv_load_policy: 3,
    modestbranding: 1,
    origin: "https://stavninasvet.si"
  }
}

class CustomLandingPage extends Component{

  state = {

    videoActive: false,
    videoRef: null
  }

  static contextTypes = {
    router: PropTypes.object
  }

  videoPaused = ()=>{
    this.setState({videoActive: false})
  }

  videoResumed = ()=>{
    this.setState({videoActive: true})
  }

  onVideoReady = (e)=>{
    this.setState({videoRef: e.target})
  }

  playVideo = ()=>{
    if(this.state.videoRef){

      if(!this.state.videoActive)this.state.videoRef.playVideo()
      else this.state.videoRef.pauseVideo()
    }
  }

  render(){
    const {classes} = this.props

    return(
      <div className={classes.root} >

        <Fade in={this.state.videoActive}>
          <div className={classes.videoContainer}>
            <YouTube
              videoId={this.props.freeBetPageData.ytVideoId}
              opts={opts}
              onReady={this.onVideoReady}
              onPause={this.videoPaused}
              onPlay={this.videoResumed}

            />
          </div>
        </Fade>
        <Fade in={!this.state.videoActive}>
          <div className={classes.container} onClick={this.playVideo}>
            <img className={classes.overlayImg} src={this.props.freeBetPageData.imgUrl} alt="background" />
            {
              this.props.freeBetPageData.ytVideoId && (
                <div style={{display: "flex",justifyContent:"center", position:"relative",cursor:"pointer"}}>
                  <PlayIcon  className={classes.playButton} />
                </div>
              )
            }
          </div>
        </Fade>


        <div className={classes.bottomChart}></div>
      </div>
    )
  }
}

CustomLandingPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({freeBetPageData}) => {
  return {
    freeBetPageData
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(CustomLandingPage))



// WEBPACK FOOTER //
// ./src/components/main/CustomLandingPage.js